<div class="row" *ngIf="data">

    <div class="col-xl-12" *ngFor="let dt of data;let di=index;trackBy:trackByIndex;">
        <div class="row">
            <div class="col-md-12">
                <app-upcoming></app-upcoming>
            </div>
            <div class="col-12">
                <h2 class="eventTitle" (click)="detailPage(dt[0])">
                    {{dt[0]?.event?.name ? dt[0]?.event?.name : dt[0]?.name}}
                    <!-- <span>{{data?.event?.event?.in_play == 1 ? 'In Play' : data?.event?.event?.open_date | date: 'dd/MM/YYYY hh:mm a'}}</span> -->
                    <a href="javascript:void(0)" (click)="detailPage(dt[0])" class="mo-arrowRight">
                        <i class="mdi mdi-arrow-right-bold"></i>
                    </a>
                </h2>
            </div>
        </div>
        <div *ngFor="let item of dt;trackBy:trackByIndex">
            <!-- MATCH ODDS -->
            <div class="dScreen" *ngIf="item?.market_id[0] && item?.market_id[0] == '1'">
                <div class="row mx-0">
                    <div class="col-md-12 px-0">
                        
                        <p class="match-odds">
                            <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                            <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                            {{item?.market?.market_name}}
                            <a href="javascript:void(0)">
                                <i class="mdi mdi-information-outline"></i>
                            </a>

                            <!-- <a href="javascript:void(0)" class="setting" (click)="openSettingModal(data?.event?.match_odds)">
                                <i class="mdi mdi-cog"></i>
                            </a> -->
                            <!-- <a href="javascript:void(0)" class="book" *ngIf="exposLisDis[item?.market_id]"
                            (click)="openBook(item, 'odds')">
                                <i class="mdi mdi-book"></i>
                            </a> -->
                            
                            <!-- <a href="" class="mo-arrowRight">
                                <i class="mdi mdi-arrow-right-bold"></i>
                            </a> -->
                        </p>
                        
                    </div>
                    <div class="col-md-6 col-4 text-end px-0 d-flex-end ">
                       
                        <!-- <span class="matched-count">Matched
                            <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span> -->
                        <!-- <div class="bets-mbl-show"> -->
                        
                        <!-- <a class="mob_open_bets" href="javascript:void(0)" (click)="openModal(openBets,'bets')">
                            Bets
                        </a> -->
                        <!-- </div> -->
                    </div>
                </div>

                <div class="row mx-0 odds_header">
                    <div class="col-md-5 col-7 px-0">
                        <div class="minmax mm-fi">
                            <dl class="fancy-info">
                                <dt>Min/Max</dt>
                                <dd>{{item?.market?.min_bet}}-{{item?.market?.max_bet}}</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="back2"></button>
                            <button class="back1"></button>
                            <button class="back">back</button>
                            <button class="lay">lay</button>
                            <button class="min-max-bet">
                                <dl class="fancy-info">
                                    <dt>Min/Max</dt>
                                    <dd>{{item?.market?.min_bet}}-{{item?.market?.max_bet}}</dd>
                                </dl>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mx-0 odds_body" *ngFor="let runner of item?.runners; let i=index;trackBy:trackByIndex;">
                    <div class="col-md-5 col-7 px-0">
                        <p class="team-name">
                            {{runner?.name}}
                            <span>
                                <span *ngIf="exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id]"
                                    [ngClass]="exposLisDis[runner?.market_id][runner?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'"
                                    class=""><i class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[runner?.market_id][runner?.selection_id]?.expose)}}
                                    {{(exposLisDis[runner?.market_id][runner?.selection_id]?.average &&
                                    exposLisDis[runner?.market_id][runner?.selection_id]?.average != '') ?
                                    exposLisDis[runner?.market_id][runner?.selection_id]?.average : ''}}
                                    
                                </span>
                                <!-- <span *ngIf="!(exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id])" class="minus-book"><i
                                        class="mdi mdi-arrow-right"></i> 0.00</span> -->
                                <b *ngIf="nextExpoList[item?.market_id+'-'+ runner?.selection_id]">
                                    <em class="extra-pf"
                                        [ngClass]="{'plus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] > 0, 'minus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] < 0}">({{nextExpoList[item?.market_id+'-'+
                                        runner?.selection_id]}})</em>
                                </b>
                            </span>

                        </p>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2]?.key}} back  back2"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2], '2', 'b1', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2]?.price
                                ? oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2]?.price : '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2]?.size ? oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[2]?.size : '-'}}</span>
                            </button>
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1]?.key}} back back1"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1], '1', 'b2', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1]?.price
                                ?
                                oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1]?.price :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1]?.size
                                    ?
                                    oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[1]?.size
                                    :
                                    '-'}}</span></button>
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0]?.key}} back"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0], '0', 'b3', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0]?.price
                                ?
                                oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0]?.price :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0]?.size
                                    ?
                                    oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToBack[0]?.size
                                    :
                                    '-'}}</span></button>
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0]?.key}} lay lay"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0], '0', 'l1', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0]?.price
                                ?
                                oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0]?.price :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0]?.size
                                    ?
                                    oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[0]?.size
                                    :
                                    '-'}}</span></button>
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1]?.key}} lay lay1"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1], '1', 'l2', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1]?.price
                                ?
                                oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1]?.price :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1]?.size
                                    ?
                                    oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[1]?.size
                                    :
                                    '-'}}</span></button>
                            <button class="{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2]?.key}} lay lay2"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2], '2', 'l3', 'match_odds')">{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2]?.price
                                ?
                                oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2]?.price :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2]?.size
                                    ?
                                    oddsLisDis[item?.market_id]?.runners[i]?.ex?.availableToLay[2]?.size
                                    :
                                    '-'}}</span></button>
                            <div class="suspended"
                                *ngIf="oddsLisDis[item?.market_id] && oddsLisDis[item?.market_id]?.runners[i]?.status != '' && oddsLisDis[item?.market_id]?.runners[i]?.status != 'ACTIVE'">
                                {{runner.status}}</div>
                            <div class="suspended" *ngIf="item?.event?.bet_allow == 0"></div>
                        </div>
                    </div>
                    <!-- betting table -->
                    <div class="col-md-12 px-0"
                        *ngIf="betSlipData?.market_id == item?.market_id && betSlipData?.selection_id == item?.runners[i]?.selection_id">
                        <app-bet-slip [data]="betSlipData" (closeBet)="closeBet($event)" (updateData)="updateData($event)"
                            (changeExpo)="changeExpo($event)">
                        </app-bet-slip>
                    </div>
                    <!-- betting table -->
                </div>
            </div>
            <!-- MATCH ODDS -->

            <!-- BOOK MAKER -->
            <!-- <div class="dScreen bookmaker_div" *ngIf="data?.event?.book_makers.length > 0"> -->
            <div class="dScreen" *ngIf="item?.market_id[0] && item?.market_id[0] == '8'">
                <div class="row mx-0">
                    <div class="col-md-12 px-0">
                        
                        <p class="match-odds">
                            <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                            <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                            {{item?.bookmaker?.title}}
                            <a href="javascript:void(0)">
                                <i class="mdi mdi-information-outline"></i>
                            </a>
                            <!-- <a href="" class="mo-arrowRight">
                                <i class="mdi mdi-arrow-right-bold"></i>
                            </a> -->
                        </p>
                    </div>
                    <div class="col-md-6 col-4 text-end px-0 d-flex-end">
                        
                        <!-- <span class="matched-count">Matched
                            <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span> -->
                    </div>
                </div>
                <div class="row mx-0 odds_header">
                    <div class="col-md-5 col-7 px-0">
                        <div class="minmax mm-fi">
                            <dl class="fancy-info">
                                <dt>Min/Max</dt>
                                <dd>{{item?.bookmaker?.min_bet}}-{{item?.bookmaker?.max_bet}}</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="back2"></button>
                            <button class="back1"></button>
                            <button class="back">back</button>
                            <button class="lay">lay</button>
                            <button class="min-max-bet">
                                <dl class="fancy-info">
                                    <dt>Min/Max</dt>
                                    <dd>{{item?.bookmaker?.min_bet}}-{{item?.bookmaker?.max_bet}}
                                    </dd>
                                </dl>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mx-0 odds_body" *ngFor="let runner of item?.runners; let i=index;trackBy:trackByIndex;">
                    <div class="col-md-5 col-7 px-0">
                        <p class="team-name">
                            {{runner?.name}}
                            <span *ngIf="exposLisDis[item?.market_id] && exposLisDis[item?.market_id][runner?.selection_id]"
                                [ngClass]="exposLisDis[item?.market_id][runner?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'"><i
                                    class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[item?.market_id][runner?.selection_id].expose)}}
                                {{(exposLisDis[item?.market_id][runner?.selection_id].average &&
                                exposLisDis[item?.market_id][runner?.selection_id].average != '') ?
                                exposLisDis[item?.market_id][runner?.selection_id].average : ''}}</span>
                            <!-- <span *ngIf="!(exposLisDis[item?.market_id] && exposLisDis[item?.market_id][runner?.selection_id])" class="minus-book"><i
                                    class="mdi mdi-arrow-right"></i> 0.00</span> -->
                            <!-- <span *ngIf="nextExpoList[item?.market_id+'-'+ runner?.selection_id]">
                                <span
                                    [ngClass]="{'plus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] > 0, 'minus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] < 0}">({{nextExpoList[item?.market_id+'-'+
                                    runner?.selection_id]}})</span></span> -->
                        </p>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.bKey2}} back  back2"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i],'2', 'b1', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back2
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back2 :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume2
                                    ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume2 :
                                    '-'}}</span></button>
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.bKey1}} back back1"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i], '1', 'b2', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back1
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back1 :
                                '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume1
                                    ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume1 :
                                    '-'}}</span></button>
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.bKey}} back"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i], '', 'b3', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back : '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume
                                    ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.back_volume :
                                    '-'}}</span></button>
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lKey}} lay lay"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i], '', 'l1', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay : '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume ?
                                    oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume :
                                    '-'}}</span></button>
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lKey1}} lay lay1"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i], '1', 'l2', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay1
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay1 : '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume1
                                    ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume1 :
                                    '-'}}</span></button>
                            <button
                                class="{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lKey2}} lay lay2"
                                (click)="openBetPlace(item, oddsLisDis[item?.market_id], i, oddsLisDis[item?.market_id]?.book_maker_odds[i], '2', 'l3', 'book_makers')">{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay2
                                ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay2 : '-'}}
                                <span>{{oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume2
                                    ? oddsLisDis[item?.market_id]?.book_maker_odds[i]?.lay_volume2 :
                                    '-'}}</span></button>
                            <div class="suspended"
                                *ngIf="oddsLisDis[item?.market_id]?.book_maker_odds[i]?.suspended == 1 || oddsLisDis[data?.event?.book_makers[0]?.market_id]?.bet_allow == 0">
                                suspended</div>
                            <!-- <div class="suspended" *ngIf="item?.event?.bet_allow == 0"> suspended</div> -->
                        </div>
                    </div>
                    <!-- betting table -->
                    <div class="col-md-12 px-0"
                        *ngIf="betSlipData?.market_id == item?.market_id && betSlipData?.selection_id == oddsLisDis[item?.market_id]?.book_maker_odds[i]?.selection_id">
                        <app-bet-slip [data]="betSlipData" (closeBet)="closeBet($event)" (updateData)="updateData($event)"
                            (changeExpo)="changeExpo($event)">
                        </app-bet-slip>
                    </div>
                    <!-- betting table -->
                </div>
            </div>
            <!-- BOOK MAKER -->

            <!-- FANCY -->
            <div class="dScreen fancy_odds" *ngIf="item?.market_id[0] && item?.market_id[0] == '9'">
                <div class="row mx-0">
                    <div class="col-md-12 px-0">
                        <p class="match-odds">
                            Fancy <i class="mdi mdi-information-outline"></i>
                            <!-- <a href="" class="mo-arrowRight">
                                <i class="mdi mdi-arrow-right-bold"></i>
                            </a> -->
                        </p>
                    </div>
                    <!-- <div class="col-md-6 col-4 text-end px-0">
                        <span class="matched-count">Matched <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span>
                    </div> -->
                </div>
                <div class="row mx-0 odds_header">
                    <div class="col-md-5 col-7 px-0">
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="lay2"></button>
                            <button class="lay1"></button>
                            <button class="lay">no</button>
                            <button class="back">yes</button>
                            <!-- <button class="min-max-bet">Min-Max</button> -->
                        </div>
                    </div>
                </div>
                <div *ngFor="let fancyDt of item?.data; let i=index;trackBy:trackByIndex;">
                    <div class="row mx-0 odds_body">
                        <div class="col-md-5 col-7 px-0">
                            <p class="team-name">
                            <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(fancyDt?.market_id)" (click)="multiMarketUpdate(fancyDt, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                            <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(fancyDt?.market_id)" (click)="multiMarketUpdate(fancyDt, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"></a>
                            
                                {{fancyDt?.fancy?.name}}
                                <span *ngIf="exposLisDis[fancyDt?.market_id] && exposLisDis[fancyDt?.market_id][fancyDt?.fancy?.selection_id]"
                                    [ngClass]="exposLisDis[fancyDt?.market_id][fancyDt?.fancy?.selection_id]?.expose >= 0 ? 'plus-book' : 'minus-book'" (click)="fancyRunPosition(fancyRunModal, fancyDt)"><i
                                        class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[fancyDt?.market_id][fancyDt?.fancy?.selection_id]?.expose)
                                    }}</span>
                                <!-- <span *ngIf="!(exposLisDis[fancyDt?.market_id] && exposLisDis[fancyDt?.market_id][fancyDt?.fancy?.selection_id])" class="minus-book"><i class="mdi mdi-arrow-right"></i>
                                    0.00</span> -->
                            </p>
                        </div>
                        <div class="col-md-7 col-5 px-0">
                            <div class="btn-group dOddsBox">
                                <button class="back back2"></button>
                                <button class="back back1">
                                    <a class="book" hef="javascript:void(0)" *ngIf="exposLisDis[fancyDt?.market_id] && exposLisDis[fancyDt?.market_id][fancyDt?.fancy?.selection_id]"
                                        (click)="fancyRunPosition(fancyRunModal, fancyDt?.fancy)">book</a>
                                </button>
                                <button class="{{oddsLisDis[fancyDt?.market_id]?.lKey}} lay"
                                    *ngIf="oddsLisDis[fancyDt?.market_id]?.active_rate == 1"
                                    (click)="openBetPlace(fancyDt?.fancy, oddsLisDis[fancyDt?.market_id], '', oddsLisDis[fancyDt?.market_id], '', 'l3', 'fancy')">{{oddsLisDis[fancyDt?.market_id]?.lay_price
                                    ? oddsLisDis[fancyDt?.market_id]?.lay_price :
                                    '-'}} <span>{{oddsLisDis[fancyDt?.market_id]?.lay_rate ?
                                        oddsLisDis[fancyDt?.market_id]?.lay_rate :
                                        '-'}}</span></button>
                                <button class="{{oddsLisDis[fancyDt?.market_id]?.bKey}} back"
                                    *ngIf="oddsLisDis[fancyDt?.market_id]?.active_rate == 1"
                                    (click)="openBetPlace(fancyDt?.fancy, oddsLisDis[fancyDt?.market_id], '', oddsLisDis[fancyDt?.market_id], '', 'b1', 'fancy')">{{oddsLisDis[fancyDt?.market_id]?.back_price
                                    ? oddsLisDis[fancyDt?.market_id]?.back_price :
                                    '-'}} <span>{{oddsLisDis[fancyDt?.market_id]?.back_rate ?
                                        oddsLisDis[fancyDt?.market_id]?.back_rate :
                                        '-'}}</span></button>
                                <button class="min-max-bet">
                                    <dl class="fancy-info">
                                        <dd>{{fancyDt?.fancy?.min_bet}}-{{fancyDt?.fancy?.max_bet}}</dd>
                                    </dl>
                                </button>
                                <div class="suspended" *ngIf="oddsLisDis[fancyDt?.market_id]?.suspended == 1">suspended</div>
                                <div class="suspended" *ngIf="oddsLisDis[fancyDt?.market_id]?.ball_running == 1">ball running
                                </div>
                                <div class="suspended" *ngIf="fancyDt?.event?.bet_allow == 0"></div>
                            </div>
                        </div>
                        <!-- betting table -->
                        <!-- //selection_id not getting in fancy response -->
                        <div class="col-md-12 px-0"
                            *ngIf="betSlipData?.market_id == fancyDt?.market_id && betSlipData?.selection_id == fancyDt?.fancy?.selection_id">
                            <app-bet-slip [data]="betSlipData" (closeBet)="closeBet($event)"
                                (updateData)="updateData($event)" (changeExpo)="changeExpo($event)">
                            </app-bet-slip>
                        </div>
                        <!-- betting table -->
                    </div>
                </div>
            </div>
            <!-- FANCY -->
        </div>
    </div> <!-- end col -->

    <!-- <div *ngIf="data?.length == 0" style="display: flex;justify-content: center;"> <h4>No Data To Display</h4></div> -->

    <div *ngIf="data?.length == 0" style="display: block;" class="no-data">
        <h3>There are currently no followed multi markets.
        </h3>
        <p>Please add some markets from events.</p>
    </div>
</div>

<app-loader class="no-overlay" *ngIf="!data"></app-loader>

<ng-template #fancyRunModal>
    <div class="modal-header">
        <h6 class="modal-title">Book</h6>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="col-md-12">
            <table>
                <thead>
                    <th>Run</th>
                    <th>Amount</th>
                </thead>
                <tbody>
                    <tr *ngFor="let item of fancyRun;trackBy:trackByIndex;">
                        <td>{{item.run}}</td>
                        <td [ngClass]="(item.expose >= 0) ? 'text-green' : 'text-red'">{{item.expose}}</td>
                    </tr>
                </tbody>
                <!-- <tfoot>
                    <tr>
                        <td class="no-data-available" colspan="2">No data!</td>
                    </tr>
                </tfoot> -->
            </table>
        </div>
    </div>
</ng-template>


<!-- book -->

<div id="BookClient" class="modal fade" bsModal #bookModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modalUI">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Book </h5>
        <button type="button" class="close" (click)="bookModal?.hide()">×</button>
      </div>

      <div class="modal-body p-1">
        <div class="table-responsive">
          <table class="table mb-0" *ngIf="bookDetail">
            <thead>
              <!-- match_odds book headers -->
              <tr *ngIf="bookDetail?.header?.runners">
                <th>sr</th>
                <th>username</th>
                <th *ngFor="let item of bookDetail?.header?.runners;trackBy:trackByIndex;">{{item?.name}}</th>
              </tr>
              <!-- match_odds book headers -->

              <!-- bookmaker book headers -->
              <tr *ngIf="bookDetail?.header?.book_maker_odds">
                <th>sr</th>
                <th>username</th>
                <th *ngFor="let item of bookDetail?.header?.book_maker_odds;trackBy:trackByIndex;">{{item?.name}}</th>
              </tr>
              <!-- bookmaker book headers -->

            </thead>
            <tbody>
              <tr>
                <td>1</td>

                <td>upline</td>
                <td *ngFor="let item of bookDetail?.own_expose;trackBy:trackByIndex;"
                  [ngClass]="item?.parent_book >= 0 ? 'profit' : 'loss'">{{item?.parent_book}}</td>
              </tr>
              <tr *ngFor="let book of bookDetail?.exposes;let i=index;trackBy:trackByIndex;">
                <td>{{i + 2}}</td>
                <td><a href="javascript:void(0);"
                    (click)="detailPage(book[0]?.user?.id)">{{book[0]?.user?.username}}</a></td>
                <td *ngFor="let item of book;trackBy:trackByIndex;"
                  [ngClass]="item?.parent_book >= 0 ? 'profit' : 'loss'">{{item?.parent_book}}</td>
              </tr>
              <tr>
                <td>{{bookDetail?.exposes?.length + 2}}</td>
                <td>total</td>
                <td *ngFor="let item of bookDetail?.total;trackBy:trackByIndex;"
                  [ngClass]="item >= 0 ? 'profit' : 'loss'">{{item}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- book -->
